'use strict';

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Account2FA = exports.AccountMultisig = exports.MultisigStateStatus = exports.MultisigDeleteRequestRejectionError = exports.MULTISIG_CONFIRM_METHODS = exports.MULTISIG_CHANGE_METHODS = exports.MULTISIG_DEPOSIT = exports.MULTISIG_GAS = exports.MULTISIG_ALLOWANCE = exports.MULTISIG_STORAGE_KEY = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var account_1 = require("./account");
var format_1 = require("./utils/format");
var key_pair_1 = require("./utils/key_pair");
var transaction_1 = require("./transaction");
var providers_1 = require("./providers");
var web_1 = require("./utils/web");
exports.MULTISIG_STORAGE_KEY = '__multisigRequest';
exports.MULTISIG_ALLOWANCE = new bn_js_1.default((0, format_1.parseNearAmount)('1'));
// TODO: Different gas value for different requests (can reduce gas usage dramatically)
exports.MULTISIG_GAS = new bn_js_1.default('100000000000000');
exports.MULTISIG_DEPOSIT = new bn_js_1.default('0');
exports.MULTISIG_CHANGE_METHODS = ['add_request', 'add_request_and_confirm', 'delete_request', 'confirm'];
exports.MULTISIG_CONFIRM_METHODS = ['confirm'];
var MultisigDeleteRequestRejectionError;
(function (MultisigDeleteRequestRejectionError) {
  MultisigDeleteRequestRejectionError["CANNOT_DESERIALIZE_STATE"] = "Cannot deserialize the contract state";
  MultisigDeleteRequestRejectionError["MULTISIG_NOT_INITIALIZED"] = "Smart contract panicked: Multisig contract should be initialized before usage";
  MultisigDeleteRequestRejectionError["NO_SUCH_REQUEST"] = "Smart contract panicked: panicked at 'No such request: either wrong number or already confirmed'";
  MultisigDeleteRequestRejectionError["REQUEST_COOLDOWN_ERROR"] = "Request cannot be deleted immediately after creation.";
  MultisigDeleteRequestRejectionError["METHOD_NOT_FOUND"] = "Contract method is not found";
})(MultisigDeleteRequestRejectionError = exports.MultisigDeleteRequestRejectionError || (exports.MultisigDeleteRequestRejectionError = {}));
var MultisigStateStatus;
(function (MultisigStateStatus) {
  MultisigStateStatus[MultisigStateStatus["INVALID_STATE"] = 0] = "INVALID_STATE";
  MultisigStateStatus[MultisigStateStatus["STATE_NOT_INITIALIZED"] = 1] = "STATE_NOT_INITIALIZED";
  MultisigStateStatus[MultisigStateStatus["VALID_STATE"] = 2] = "VALID_STATE";
  MultisigStateStatus[MultisigStateStatus["UNKNOWN_STATE"] = 3] = "UNKNOWN_STATE";
})(MultisigStateStatus = exports.MultisigStateStatus || (exports.MultisigStateStatus = {}));
var MultisigCodeStatus;
(function (MultisigCodeStatus) {
  MultisigCodeStatus[MultisigCodeStatus["INVALID_CODE"] = 0] = "INVALID_CODE";
  MultisigCodeStatus[MultisigCodeStatus["VALID_CODE"] = 1] = "VALID_CODE";
  MultisigCodeStatus[MultisigCodeStatus["UNKNOWN_CODE"] = 2] = "UNKNOWN_CODE";
})(MultisigCodeStatus || (MultisigCodeStatus = {}));
// in memory request cache for node w/o localStorage
var storageFallback = _defineProperty({}, exports.MULTISIG_STORAGE_KEY, null);
var AccountMultisig = /*#__PURE__*/function (_account_1$Account) {
  _inherits(AccountMultisig, _account_1$Account);
  var _super2 = _createSuper(AccountMultisig);
  function AccountMultisig(connection, accountId, options) {
    var _this;
    _classCallCheck(this, AccountMultisig);
    _this = _super2.call(this, connection, accountId);
    _this.storage = options.storage;
    _this.onAddRequestResult = options.onAddRequestResult;
    return _this;
  }
  _createClass(AccountMultisig, [{
    key: "signAndSendTransactionWithAccount",
    value: function signAndSendTransactionWithAccount(receiverId, actions) {
      var _this2 = this;
      var _super = Object.create(null, {
        signAndSendTransaction: {
          get: function get() {
            return _get(_getPrototypeOf(AccountMultisig.prototype), "signAndSendTransaction", _this2);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _super.signAndSendTransaction.call(this, {
                receiverId: receiverId,
                actions: actions
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "signAndSendTransaction",
    value: function signAndSendTransaction(_ref) {
      var _this3 = this;
      var receiverId = _ref.receiverId,
        actions = _ref.actions;
      var _super = Object.create(null, {
        signAndSendTransaction: {
          get: function get() {
            return _get(_getPrototypeOf(AccountMultisig.prototype), "signAndSendTransaction", _this3);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var accountId, args, result, status;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              accountId = this.accountId;
              args = Buffer.from(JSON.stringify({
                request: {
                  receiver_id: receiverId,
                  actions: convertActions(actions, accountId, receiverId)
                }
              }));
              _context2.prev = 2;
              _context2.next = 5;
              return _super.signAndSendTransaction.call(this, {
                receiverId: accountId,
                actions: [(0, transaction_1.functionCall)('add_request_and_confirm', args, exports.MULTISIG_GAS, exports.MULTISIG_DEPOSIT)]
              });
            case 5:
              result = _context2.sent;
              _context2.next = 17;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              if (!_context2.t0.toString().includes('Account has too many active requests. Confirm or delete some')) {
                _context2.next = 16;
                break;
              }
              _context2.next = 13;
              return this.deleteUnconfirmedRequests();
            case 13:
              _context2.next = 15;
              return this.signAndSendTransaction({
                receiverId: receiverId,
                actions: actions
              });
            case 15:
              return _context2.abrupt("return", _context2.sent);
            case 16:
              throw _context2.t0;
            case 17:
              if (result.status) {
                _context2.next = 19;
                break;
              }
              throw new Error('Request failed');
            case 19:
              status = Object.assign({}, result.status);
              if (!(!status.SuccessValue || typeof status.SuccessValue !== 'string')) {
                _context2.next = 22;
                break;
              }
              throw new Error('Request failed');
            case 22:
              this.setRequest({
                accountId: accountId,
                actions: actions,
                requestId: parseInt(Buffer.from(status.SuccessValue, 'base64').toString('ascii'), 10)
              });
              if (!this.onAddRequestResult) {
                _context2.next = 26;
                break;
              }
              _context2.next = 26;
              return this.onAddRequestResult(result);
            case 26:
              // NOTE there is no await on purpose to avoid blocking for 2fa
              this.deleteUnconfirmedRequests();
              return _context2.abrupt("return", result);
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 8]]);
      }));
    }
    /*
     * This method submits a canary transaction that is expected to always fail in order to determine whether the contract currently has valid multisig state
     * and whether it is initialized. The canary transaction attempts to delete a request at index u32_max and will go through if a request exists at that index.
     * a u32_max + 1 and -1 value cannot be used for the canary due to expected u32 error thrown before deserialization attempt.
     */
  }, {
    key: "checkMultisigCodeAndStateStatus",
    value: function checkMultisigCodeAndStateStatus(contractBytes) {
      var _this4 = this;
      var _super = Object.create(null, {
        signAndSendTransaction: {
          get: function get() {
            return _get(_getPrototypeOf(AccountMultisig.prototype), "signAndSendTransaction", _this4);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var u32_max, validCodeStatusIfNoDeploy;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              u32_max = 4294967295;
              validCodeStatusIfNoDeploy = contractBytes ? MultisigCodeStatus.UNKNOWN_CODE : MultisigCodeStatus.VALID_CODE;
              _context3.prev = 2;
              if (!contractBytes) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return _super.signAndSendTransaction.call(this, {
                receiverId: this.accountId,
                actions: [(0, transaction_1.deployContract)(contractBytes), (0, transaction_1.functionCall)('delete_request', {
                  request_id: u32_max
                }, exports.MULTISIG_GAS, exports.MULTISIG_DEPOSIT)]
              });
            case 6:
              _context3.next = 10;
              break;
            case 8:
              _context3.next = 10;
              return this.deleteRequest(u32_max);
            case 10:
              return _context3.abrupt("return", {
                codeStatus: MultisigCodeStatus.VALID_CODE,
                stateStatus: MultisigStateStatus.VALID_STATE
              });
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](2);
              if (!new RegExp(MultisigDeleteRequestRejectionError.CANNOT_DESERIALIZE_STATE).test(_context3.t0 && _context3.t0.kind && _context3.t0.kind.ExecutionError)) {
                _context3.next = 19;
                break;
              }
              return _context3.abrupt("return", {
                codeStatus: validCodeStatusIfNoDeploy,
                stateStatus: MultisigStateStatus.INVALID_STATE
              });
            case 19:
              if (!new RegExp(MultisigDeleteRequestRejectionError.MULTISIG_NOT_INITIALIZED).test(_context3.t0 && _context3.t0.kind && _context3.t0.kind.ExecutionError)) {
                _context3.next = 23;
                break;
              }
              return _context3.abrupt("return", {
                codeStatus: validCodeStatusIfNoDeploy,
                stateStatus: MultisigStateStatus.STATE_NOT_INITIALIZED
              });
            case 23:
              if (!new RegExp(MultisigDeleteRequestRejectionError.NO_SUCH_REQUEST).test(_context3.t0 && _context3.t0.kind && _context3.t0.kind.ExecutionError)) {
                _context3.next = 27;
                break;
              }
              return _context3.abrupt("return", {
                codeStatus: validCodeStatusIfNoDeploy,
                stateStatus: MultisigStateStatus.VALID_STATE
              });
            case 27:
              if (!new RegExp(MultisigDeleteRequestRejectionError.METHOD_NOT_FOUND).test(_context3.t0 && _context3.t0.message)) {
                _context3.next = 29;
                break;
              }
              return _context3.abrupt("return", {
                codeStatus: MultisigCodeStatus.INVALID_CODE,
                stateStatus: MultisigStateStatus.UNKNOWN_STATE
              });
            case 29:
              throw _context3.t0;
            case 30:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 13]]);
      }));
    }
  }, {
    key: "deleteRequest",
    value: function deleteRequest(request_id) {
      return _get(_getPrototypeOf(AccountMultisig.prototype), "signAndSendTransaction", this).call(this, {
        receiverId: this.accountId,
        actions: [(0, transaction_1.functionCall)('delete_request', {
          request_id: request_id
        }, exports.MULTISIG_GAS, exports.MULTISIG_DEPOSIT)]
      });
    }
  }, {
    key: "deleteAllRequests",
    value: function deleteAllRequests() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;
        var request_ids;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getRequestIds();
            case 2:
              request_ids = _context4.sent;
              if (!request_ids.length) {
                _context4.next = 6;
                break;
              }
              _context4.next = 6;
              return Promise.all(request_ids.map(function (id) {
                return _this5.deleteRequest(id);
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "deleteUnconfirmedRequests",
    value: function deleteUnconfirmedRequests() {
      var _this6 = this;
      var _super = Object.create(null, {
        signAndSendTransaction: {
          get: function get() {
            return _get(_getPrototypeOf(AccountMultisig.prototype), "signAndSendTransaction", _this6);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var request_ids, _this$getRequest, requestId, _iterator, _step, requestIdToDelete;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getRequestIds();
            case 2:
              request_ids = _context5.sent;
              _this$getRequest = this.getRequest(), requestId = _this$getRequest.requestId;
              _iterator = _createForOfIteratorHelper(request_ids);
              _context5.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context5.next = 21;
                break;
              }
              requestIdToDelete = _step.value;
              if (!(requestIdToDelete == requestId)) {
                _context5.next = 11;
                break;
              }
              return _context5.abrupt("continue", 19);
            case 11:
              _context5.prev = 11;
              _context5.next = 14;
              return _super.signAndSendTransaction.call(this, {
                receiverId: this.accountId,
                actions: [(0, transaction_1.functionCall)('delete_request', {
                  request_id: requestIdToDelete
                }, exports.MULTISIG_GAS, exports.MULTISIG_DEPOSIT)]
              });
            case 14:
              _context5.next = 19;
              break;
            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](11);
              console.warn('Attempt to delete an earlier request before 15 minutes failed. Will try again.');
            case 19:
              _context5.next = 7;
              break;
            case 21:
              _context5.next = 26;
              break;
            case 23:
              _context5.prev = 23;
              _context5.t1 = _context5["catch"](5);
              _iterator.e(_context5.t1);
            case 26:
              _context5.prev = 26;
              _iterator.f();
              return _context5.finish(26);
            case 29:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[5, 23, 26, 29], [11, 16]]);
      }));
    }
    // helpers
  }, {
    key: "getRequestIds",
    value: function getRequestIds() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.viewFunction(this.accountId, 'list_request_ids'));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getRequest",
    value: function getRequest() {
      if (this.storage) {
        return JSON.parse(this.storage.getItem(exports.MULTISIG_STORAGE_KEY) || '{}');
      }
      return storageFallback[exports.MULTISIG_STORAGE_KEY];
    }
  }, {
    key: "setRequest",
    value: function setRequest(data) {
      if (this.storage) {
        return this.storage.setItem(exports.MULTISIG_STORAGE_KEY, JSON.stringify(data));
      }
      storageFallback[exports.MULTISIG_STORAGE_KEY] = data;
    }
  }]);
  return AccountMultisig;
}(account_1.Account);
exports.AccountMultisig = AccountMultisig;
var Account2FA = /*#__PURE__*/function (_AccountMultisig) {
  _inherits(Account2FA, _AccountMultisig);
  var _super3 = _createSuper(Account2FA);
  function Account2FA(connection, accountId, options) {
    var _this7;
    _classCallCheck(this, Account2FA);
    _this7 = _super3.call(this, connection, accountId, options);
    _this7.helperUrl = 'https://helper.testnet.near.org';
    _this7.helperUrl = options.helperUrl || _this7.helperUrl;
    _this7.storage = options.storage;
    _this7.sendCode = options.sendCode || _this7.sendCodeDefault;
    _this7.getCode = options.getCode || _this7.getCodeDefault;
    _this7.verifyCode = options.verifyCode || _this7.verifyCodeDefault;
    _this7.onConfirmResult = options.onConfirmResult;
    return _this7;
  }
  /**
   * Sign a transaction to preform a list of actions and broadcast it using the RPC API.
   * @see {@link providers/json-rpc-provider!JsonRpcProvider#sendTransaction | JsonRpcProvider.sendTransaction}
   */
  _createClass(Account2FA, [{
    key: "signAndSendTransaction",
    value: function signAndSendTransaction(_ref2) {
      var _this8 = this;
      var receiverId = _ref2.receiverId,
        actions = _ref2.actions;
      var _super = Object.create(null, {
        signAndSendTransaction: {
          get: function get() {
            return _get(_getPrototypeOf(Account2FA.prototype), "signAndSendTransaction", _this8);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _super.signAndSendTransaction.call(this, {
                receiverId: receiverId,
                actions: actions
              });
            case 2:
              _context7.next = 4;
              return this.sendCode();
            case 4:
              _context7.next = 6;
              return this.promptAndVerify();
            case 6:
              result = _context7.sent;
              if (!this.onConfirmResult) {
                _context7.next = 10;
                break;
              }
              _context7.next = 10;
              return this.onConfirmResult(result);
            case 10:
              return _context7.abrupt("return", result);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
    // default helpers for CH deployments of multisig
  }, {
    key: "deployMultisig",
    value: function deployMultisig(contractBytes) {
      var _this9 = this;
      var _super = Object.create(null, {
        signAndSendTransactionWithAccount: {
          get: function get() {
            return _get(_getPrototypeOf(Account2FA.prototype), "signAndSendTransactionWithAccount", _this9);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var accountId, seedOrLedgerKey, fak2lak, confirmOnlyKey, newArgs, actions, newFunctionCallActionBatch, _yield$this$checkMult, multisigStateStatus;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              accountId = this.accountId;
              _context8.next = 3;
              return this.getRecoveryMethods();
            case 3:
              seedOrLedgerKey = _context8.sent.data.filter(function (_ref3) {
                var kind = _ref3.kind,
                  publicKey = _ref3.publicKey;
                return (kind === 'phrase' || kind === 'ledger') && publicKey !== null;
              }).map(function (rm) {
                return rm.publicKey;
              });
              _context8.next = 6;
              return this.getAccessKeys();
            case 6:
              fak2lak = _context8.sent.filter(function (_ref4) {
                var public_key = _ref4.public_key,
                  permission = _ref4.access_key.permission;
                return permission === 'FullAccess' && !seedOrLedgerKey.includes(public_key);
              }).map(function (ak) {
                return ak.public_key;
              }).map(toPK);
              _context8.t0 = toPK;
              _context8.next = 10;
              return this.postSignedJson('/2fa/getAccessKey', {
                accountId: accountId
              });
            case 10:
              _context8.t1 = _context8.sent.publicKey;
              confirmOnlyKey = (0, _context8.t0)(_context8.t1);
              newArgs = Buffer.from(JSON.stringify({
                'num_confirmations': 2
              }));
              actions = [].concat(_toConsumableArray(fak2lak.map(function (pk) {
                return (0, transaction_1.deleteKey)(pk);
              })), _toConsumableArray(fak2lak.map(function (pk) {
                return (0, transaction_1.addKey)(pk, (0, transaction_1.functionCallAccessKey)(accountId, exports.MULTISIG_CHANGE_METHODS, null));
              })), [(0, transaction_1.addKey)(confirmOnlyKey, (0, transaction_1.functionCallAccessKey)(accountId, exports.MULTISIG_CONFIRM_METHODS, null)), (0, transaction_1.deployContract)(contractBytes)]);
              newFunctionCallActionBatch = actions.concat((0, transaction_1.functionCall)('new', newArgs, exports.MULTISIG_GAS, exports.MULTISIG_DEPOSIT));
              console.log('deploying multisig contract for', accountId);
              _context8.next = 18;
              return this.checkMultisigCodeAndStateStatus(contractBytes);
            case 18:
              _yield$this$checkMult = _context8.sent;
              multisigStateStatus = _yield$this$checkMult.stateStatus;
              _context8.t2 = multisigStateStatus;
              _context8.next = _context8.t2 === MultisigStateStatus.STATE_NOT_INITIALIZED ? 23 : _context8.t2 === MultisigStateStatus.VALID_STATE ? 26 : _context8.t2 === MultisigStateStatus.INVALID_STATE ? 29 : 30;
              break;
            case 23:
              _context8.next = 25;
              return _super.signAndSendTransactionWithAccount.call(this, accountId, newFunctionCallActionBatch);
            case 25:
              return _context8.abrupt("return", _context8.sent);
            case 26:
              _context8.next = 28;
              return _super.signAndSendTransactionWithAccount.call(this, accountId, actions);
            case 28:
              return _context8.abrupt("return", _context8.sent);
            case 29:
              throw new providers_1.TypedError("Can not deploy a contract to account ".concat(this.accountId, " on network ").concat(this.connection.networkId, ", the account has existing state."), 'ContractHasExistingState');
            case 30:
              throw new providers_1.TypedError("Can not deploy a contract to account ".concat(this.accountId, " on network ").concat(this.connection.networkId, ", the account state could not be verified."), 'ContractStateUnknown');
            case 31:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "disableWithFAK",
    value: function disableWithFAK(_ref5) {
      var contractBytes = _ref5.contractBytes,
        cleanupContractBytes = _ref5.cleanupContractBytes;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var cleanupActions, keyConversionActions, actions, accessKeyInfo;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              cleanupActions = [];
              if (!cleanupContractBytes) {
                _context9.next = 7;
                break;
              }
              _context9.next = 4;
              return this.deleteAllRequests().catch(function (e) {
                return e;
              });
            case 4:
              _context9.next = 6;
              return this.get2faDisableCleanupActions(cleanupContractBytes);
            case 6:
              cleanupActions = _context9.sent;
            case 7:
              _context9.next = 9;
              return this.get2faDisableKeyConversionActions();
            case 9:
              keyConversionActions = _context9.sent;
              actions = [].concat(_toConsumableArray(cleanupActions), _toConsumableArray(keyConversionActions), [(0, transaction_1.deployContract)(contractBytes)]);
              _context9.next = 13;
              return this.findAccessKey(this.accountId, actions);
            case 13:
              accessKeyInfo = _context9.sent;
              if (!(accessKeyInfo && accessKeyInfo.accessKey && accessKeyInfo.accessKey.permission !== 'FullAccess')) {
                _context9.next = 16;
                break;
              }
              throw new providers_1.TypedError('No full access key found in keystore. Unable to bypass multisig', 'NoFAKFound');
            case 16:
              return _context9.abrupt("return", this.signAndSendTransactionWithAccount(this.accountId, actions));
            case 17:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "get2faDisableCleanupActions",
    value: function get2faDisableCleanupActions(cleanupContractBytes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this10 = this;
        var currentAccountState, currentAccountStateKeys;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.viewState('').catch(function (error) {
                var cause = error.cause && error.cause.name;
                if (cause == 'NO_CONTRACT_CODE') {
                  return [];
                }
                throw cause == 'TOO_LARGE_CONTRACT_STATE' ? new providers_1.TypedError("Can not deploy a contract to account ".concat(_this10.accountId, " on network ").concat(_this10.connection.networkId, ", the account has existing state."), 'ContractHasExistingState') : error;
              });
            case 2:
              currentAccountState = _context10.sent;
              currentAccountStateKeys = currentAccountState.map(function (_ref6) {
                var key = _ref6.key;
                return key.toString('base64');
              });
              return _context10.abrupt("return", currentAccountState.length ? [(0, transaction_1.deployContract)(cleanupContractBytes), (0, transaction_1.functionCall)('clean', {
                keys: currentAccountStateKeys
              }, exports.MULTISIG_GAS, new bn_js_1.default('0'))] : []);
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "get2faDisableKeyConversionActions",
    value: function get2faDisableKeyConversionActions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var accountId, accessKeys, lak2fak, confirmOnlyKey;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              accountId = this.accountId;
              _context11.next = 3;
              return this.getAccessKeys();
            case 3:
              accessKeys = _context11.sent;
              lak2fak = accessKeys.filter(function (_ref7) {
                var access_key = _ref7.access_key;
                return access_key.permission !== 'FullAccess';
              }).filter(function (_ref8) {
                var access_key = _ref8.access_key;
                var perm = access_key.permission.FunctionCall;
                return perm.receiver_id === accountId && perm.method_names.length === 4 && perm.method_names.includes('add_request_and_confirm');
              });
              _context11.t0 = key_pair_1.PublicKey;
              _context11.next = 8;
              return this.postSignedJson('/2fa/getAccessKey', {
                accountId: accountId
              });
            case 8:
              _context11.t1 = _context11.sent.publicKey;
              confirmOnlyKey = _context11.t0.from.call(_context11.t0, _context11.t1);
              return _context11.abrupt("return", [(0, transaction_1.deleteKey)(confirmOnlyKey)].concat(_toConsumableArray(lak2fak.map(function (_ref9) {
                var public_key = _ref9.public_key;
                return (0, transaction_1.deleteKey)(key_pair_1.PublicKey.from(public_key));
              })), _toConsumableArray(lak2fak.map(function (_ref10) {
                var public_key = _ref10.public_key;
                return (0, transaction_1.addKey)(key_pair_1.PublicKey.from(public_key), (0, transaction_1.fullAccessKey)());
              }))));
            case 11:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
    /**
     * This method converts LAKs back to FAKs, clears state and deploys an 'empty' contract (contractBytes param)
     * @param [contractBytes]{@link https://github.com/near/near-wallet/blob/master/packages/frontend/src/wasm/main.wasm?raw=true}
     * @param [cleanupContractBytes]{@link https://github.com/near/core-contracts/blob/master/state-cleanup/res/state_cleanup.wasm?raw=true}
     */
  }, {
    key: "disable",
    value: function disable(contractBytes, cleanupContractBytes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _yield$this$checkMult2, stateStatus, deleteAllRequestsError, cleanupActions, actions;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.checkMultisigCodeAndStateStatus();
            case 2:
              _yield$this$checkMult2 = _context12.sent;
              stateStatus = _yield$this$checkMult2.stateStatus;
              if (!(stateStatus !== MultisigStateStatus.VALID_STATE && stateStatus !== MultisigStateStatus.STATE_NOT_INITIALIZED)) {
                _context12.next = 6;
                break;
              }
              throw new providers_1.TypedError("Can not deploy a contract to account ".concat(this.accountId, " on network ").concat(this.connection.networkId, ", the account state could not be verified."), 'ContractStateUnknown');
            case 6:
              _context12.next = 8;
              return this.deleteAllRequests().catch(function (e) {
                return deleteAllRequestsError = e;
              });
            case 8:
              _context12.next = 10;
              return this.get2faDisableCleanupActions(cleanupContractBytes).catch(function (e) {
                if (e.type === 'ContractHasExistingState') {
                  throw deleteAllRequestsError || e;
                }
                throw e;
              });
            case 10:
              cleanupActions = _context12.sent;
              _context12.t0 = [];
              _context12.t1 = _toConsumableArray(cleanupActions);
              _context12.t2 = _toConsumableArray;
              _context12.next = 16;
              return this.get2faDisableKeyConversionActions();
            case 16:
              _context12.t3 = _context12.sent;
              _context12.t4 = (0, _context12.t2)(_context12.t3);
              _context12.t5 = [(0, transaction_1.deployContract)(contractBytes)];
              actions = _context12.t0.concat.call(_context12.t0, _context12.t1, _context12.t4, _context12.t5);
              console.log('disabling 2fa for', this.accountId);
              _context12.next = 23;
              return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: actions
              });
            case 23:
              return _context12.abrupt("return", _context12.sent);
            case 24:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "sendCodeDefault",
    value: function sendCodeDefault() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var accountId, _this$getRequest2, requestId, method;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              accountId = this.accountId;
              _this$getRequest2 = this.getRequest(), requestId = _this$getRequest2.requestId;
              _context13.next = 4;
              return this.get2faMethod();
            case 4:
              method = _context13.sent;
              _context13.next = 7;
              return this.postSignedJson('/2fa/send', {
                accountId: accountId,
                method: method,
                requestId: requestId
              });
            case 7:
              return _context13.abrupt("return", requestId);
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getCodeDefault",
    value: function getCodeDefault() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              throw new Error('There is no getCode callback provided. Please provide your own in AccountMultisig constructor options. It has a parameter method where method.kind is "email" or "phone".');
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
    }
  }, {
    key: "promptAndVerify",
    value: function promptAndVerify() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var method, securityCode, result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.get2faMethod();
            case 2:
              method = _context15.sent;
              _context15.next = 5;
              return this.getCode(method);
            case 5:
              securityCode = _context15.sent;
              _context15.prev = 6;
              _context15.next = 9;
              return this.verifyCode(securityCode);
            case 9:
              result = _context15.sent;
              return _context15.abrupt("return", result);
            case 13:
              _context15.prev = 13;
              _context15.t0 = _context15["catch"](6);
              console.warn('Error validating security code:', _context15.t0);
              if (!(_context15.t0.toString().includes('invalid 2fa code provided') || _context15.t0.toString().includes('2fa code not valid'))) {
                _context15.next = 20;
                break;
              }
              _context15.next = 19;
              return this.promptAndVerify();
            case 19:
              return _context15.abrupt("return", _context15.sent);
            case 20:
              throw _context15.t0;
            case 21:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[6, 13]]);
      }));
    }
  }, {
    key: "verifyCodeDefault",
    value: function verifyCodeDefault(securityCode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var accountId, request, requestId;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              accountId = this.accountId;
              request = this.getRequest();
              if (request) {
                _context16.next = 4;
                break;
              }
              throw new Error('no request pending');
            case 4:
              requestId = request.requestId;
              _context16.next = 7;
              return this.postSignedJson('/2fa/verify', {
                accountId: accountId,
                securityCode: securityCode,
                requestId: requestId
              });
            case 7:
              return _context16.abrupt("return", _context16.sent);
            case 8:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getRecoveryMethods",
    value: function getRecoveryMethods() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var accountId;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              accountId = this.accountId;
              _context17.t0 = accountId;
              _context17.next = 4;
              return this.postSignedJson('/account/recoveryMethods', {
                accountId: accountId
              });
            case 4:
              _context17.t1 = _context17.sent;
              return _context17.abrupt("return", {
                accountId: _context17.t0,
                data: _context17.t1
              });
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "get2faMethod",
    value: function get2faMethod() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _yield$this$getRecove, data, _data, kind, detail;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.getRecoveryMethods();
            case 2:
              _yield$this$getRecove = _context18.sent;
              data = _yield$this$getRecove.data;
              if (data && data.length) {
                data = data.find(function (m) {
                  return m.kind.indexOf('2fa-') === 0;
                });
              }
              if (data) {
                _context18.next = 7;
                break;
              }
              return _context18.abrupt("return", null);
            case 7:
              _data = data, kind = _data.kind, detail = _data.detail;
              return _context18.abrupt("return", {
                kind: kind,
                detail: detail
              });
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "signatureFor",
    value: function signatureFor() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var accountId, block, blockNumber, signed, blockNumberSignature;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              accountId = this.accountId;
              _context19.next = 3;
              return this.connection.provider.block({
                finality: 'final'
              });
            case 3:
              block = _context19.sent;
              blockNumber = block.header.height.toString();
              _context19.next = 7;
              return this.connection.signer.signMessage(Buffer.from(blockNumber), accountId, this.connection.networkId);
            case 7:
              signed = _context19.sent;
              blockNumberSignature = Buffer.from(signed.signature).toString('base64');
              return _context19.abrupt("return", {
                blockNumber: blockNumber,
                blockNumberSignature: blockNumberSignature
              });
            case 10:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "postSignedJson",
    value: function postSignedJson(path, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.t0 = (0, web_1.fetchJson);
              _context20.t1 = this.helperUrl + path;
              _context20.t2 = JSON;
              _context20.t3 = Object;
              _context20.t4 = Object.assign({}, body);
              _context20.next = 7;
              return this.signatureFor();
            case 7:
              _context20.t5 = _context20.sent;
              _context20.t6 = _context20.t3.assign.call(_context20.t3, _context20.t4, _context20.t5);
              _context20.t7 = _context20.t2.stringify.call(_context20.t2, _context20.t6);
              _context20.next = 12;
              return (0, _context20.t0)(_context20.t1, _context20.t7);
            case 12:
              return _context20.abrupt("return", _context20.sent);
            case 13:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }]);
  return Account2FA;
}(AccountMultisig);
exports.Account2FA = Account2FA;
// helpers
var toPK = function toPK(pk) {
  return key_pair_1.PublicKey.from(pk);
};
var convertPKForContract = function convertPKForContract(pk) {
  return pk.toString().replace('ed25519:', '');
};
var convertActions = function convertActions(actions, accountId, receiverId) {
  return actions.map(function (a) {
    var type = a.enum;
    var _a$type = a[type],
      gas = _a$type.gas,
      publicKey = _a$type.publicKey,
      methodName = _a$type.methodName,
      args = _a$type.args,
      deposit = _a$type.deposit,
      accessKey = _a$type.accessKey,
      code = _a$type.code;
    var action = {
      type: type[0].toUpperCase() + type.substr(1),
      gas: gas && gas.toString() || undefined,
      public_key: publicKey && convertPKForContract(publicKey) || undefined,
      method_name: methodName,
      args: args && Buffer.from(args).toString('base64') || undefined,
      code: code && Buffer.from(code).toString('base64') || undefined,
      amount: deposit && deposit.toString() || undefined,
      deposit: deposit && deposit.toString() || '0',
      permission: undefined
    };
    if (accessKey) {
      if (receiverId === accountId && accessKey.permission.enum !== 'fullAccess') {
        action.permission = {
          receiver_id: accountId,
          allowance: exports.MULTISIG_ALLOWANCE.toString(),
          method_names: exports.MULTISIG_CHANGE_METHODS
        };
      }
      if (accessKey.permission.enum === 'functionCall') {
        var _accessKey$permission = accessKey.permission.functionCall,
          receiver_id = _accessKey$permission.receiverId,
          method_names = _accessKey$permission.methodNames,
          allowance = _accessKey$permission.allowance;
        action.permission = {
          receiver_id: receiver_id,
          allowance: allowance && allowance.toString() || undefined,
          method_names: method_names
        };
      }
    }
    return action;
  });
};